import { render, staticRenderFns } from "./FileManagerPopup.vue?vue&type=template&id=54fda028&"
import script from "./FileManagerPopup.vue?vue&type=script&lang=js&"
export * from "./FileManagerPopup.vue?vue&type=script&lang=js&"
import style0 from "./FileManagerPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports